import React, { useEffect } from 'react';

const GetInvolved = () => {
  useEffect(() => { document.title = 'Get involved | Afterimage Labs'; }, []);

  return (
    <main>
      <section className="ai-pagehead">
        <div className="ai-wrap">
          <h1>Help us find what got missed.</h1>
          <p>
            We need doctors and nurses who know how charts get written, engineers
            who can build software that reads them, and researchers who can show
            where the system breaks down.
          </p>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>Who we're looking for</h2>
          <div className="ai-pairs">
            <div>
              <h3>Clinicians</h3>
              <p>Tell us what a missed diagnosis looks like in a chart. Your judgment shapes what our software flags.</p>
            </div>
            <div>
              <h3>Engineers</h3>
              <p>Work on AI, data, and software that reads medical records at a scale no human team can.</p>
            </div>
            <div>
              <h3>Researchers</h3>
              <p>Study why diagnoses get missed and show hospitals exactly where their process fails.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="ai-close">
        <div className="ai-wrap">
          <h2>Write to us.</h2>
          <p>Tell us what you do and why this matters to you. We read every message.</p>
          <div className="ai-actions">
            <a className="ai-btn" href="mailto:hello@afterimage.health?subject=Getting%20involved">
              Email hello@afterimage.health
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default GetInvolved;
